import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import {
  AccountFormData,
  AccountDetailData,
  AuditData,
} from '../../types/types';
import AccountProfile from '../details/AccountProfile';
import ContactInformation from '../details/ContactInformation';
import AccountDetail from '../details/AccountDetail';
import AuditProfile from '../details/AuditProfile';

const AccountDetailsTab = () => {
  const [accountFormData, setAccountFormData] = useState<AccountFormData>({
    accountId: '34',
    name: 'ABC Co',
    location: '',
    tradingName: '',
    type: '',
    industry: '',
    acn: '',
    abn: '',
    statusValue: 'Active',
    rating: '',
    mainPhoneNumber: '',
    mainFaxNumber: '',
    mainEmailAddress: '',
    webAddress: '',
    accountOwner: 'Our Business Admin',
    primaryContact: '',
    parentAccount: '',
    paymentTerms: 'COD',
    isActive: true,
    creditStatus: false,
    isSupplier: false,
  });

  const [accountDetailData, setAccountDetailData] = useState<AccountDetailData>({
    comments: '',
  });

  const [auditData, setAuditData] = useState<AuditData>({
    created: '18/01/2022 10:04:56 AM',
    createdBy: 'Our Business Admin',
    lastUpdated: '28/05/2025 03:14:45 PM',
    lastUpdatedBy: 'Our Business Admin',
    locationOwner: '',
  });

  const handleLocationOwnerChange = (value: string) => {
    setAuditData((prev) => ({ ...prev, locationOwner: value }));
  };

  return (
    <div className="page-content p-0">
      <Row className="g-3">
        {/* Account Profile - Left Column */}
        <Col sm={4}>
          <AccountProfile formData={accountFormData} setFormData={setAccountFormData} />
        </Col>

        {/* Contact Information - Middle Column */}
        <Col sm={4}>
          <ContactInformation formData={accountFormData} setFormData={setAccountFormData} />
        </Col>

        {/* Account Detail and Audit Profile - Right Column */}
        <Col sm={4}>
          <AccountDetail
            accountDetailData={accountDetailData}
            setAccountDetailData={setAccountDetailData}
          />
          <div className="mt-3">
            <AuditProfile
              auditData={auditData}
              onLocationOwnerChange={handleLocationOwnerChange}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AccountDetailsTab; 